// extracted by mini-css-extract-plugin
export default {"block":"Level_block__eth6y","title":"Level_title__b1OiN","count":"Level_count__iUy52","button":"Level_button__VPGUK"};